import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BaseFormsState } from '../reducers/base-forms.reducer';

const getForms = createFeatureSelector<BaseFormsState>('forms');

export const getStaffRequestForm = createSelector(getForms, (state) => state?.staffRequestForm);

export const getAccountRegisterForm = createSelector(getForms, (state) => state?.accountRegisterForm);
